import React from 'react';
import {useState, useEffect, useCallback} from 'react';
import IconDelete from '../icons/IconDelete';
import AutocompleteTextInput from '../common/AutocompleteTextInput';
import ProjectCollaborationCardField from './ProjectCollaborationCardField';
import Button from '../common/Button';
import IconEdit from '../icons/IconEdit'
import IconAccept from '../icons/IconAccept';

const ItemLabel = ({option, onRemoveClick, canRemove}) => {
    return (
        <span className="project-collaboration-label">
            <span>{option.text}</span>
            {canRemove && <span>
                <IconDelete size={IconDelete.Size.Tiny} onClick={() => onRemoveClick(option)}/>
            </span>}
        </span>
    )
};

export default function ProjectCollaborationCardEditableListSection({
                                                                        title,
                                                                        editable,
                                                                        value,
                                                                        autocompleteSuggestions,
                                                                        boldAutocompleteSuggestions,
                                                                        onParticipantAddClick,
                                                                        onParticipantRemoveClick,
                                                                        handleToggleEditable
                                                                    }) {

    const [duringEdit, setDuringEdit] = useState(null);
    const toLowerCase = value => value ? value.toLowerCase() : value;

    useEffect(() => {
        if (duringEdit !== null) {
            handleToggleEditable(duringEdit);
        }
    }, [duringEdit])
    /**
     * Builds a list of names to suggest to the user.
     *
     * @param {any} currentValue
     * @param {Array<any>} excluded
     * @return {Array<any>}
     */
    const buildAutocompleteSuggestions = (currentValue, excluded) => {
        let excludedIds = excluded.map(x => x.value);

        // Basically get all possible suggestions and then filter them to not
        // duplicate already selected values.
        if (typeof boldAutocompleteSuggestions !== 'undefined') {
            autocompleteSuggestions = autocompleteSuggestions.filter(x => x.value !== boldAutocompleteSuggestions.user.value);
        }
        return autocompleteSuggestions.filter(x => toLowerCase(x.text).includes(toLowerCase(currentValue)) && !excludedIds.includes(x.value));
    };

    const excludedAutocompleteSuggestions = value;
    const [addParticipantInputValue, setAddParticipantInputValue] = useState('');
    const [addParticipantAutocompleteOptions, setAddParticipantAutocompleteOptions] = useState(
        buildAutocompleteSuggestions('', excludedAutocompleteSuggestions)
    );


    const handleAddParticipantInputChange = useCallback(value => {
        setAddParticipantInputValue(value);
    });

    const handleAddParticipantInputSubmit = useCallback(() => {
        onParticipantAddClick(addParticipantInputValue);
        setAddParticipantInputValue('');
    }, [onParticipantAddClick, addParticipantInputValue]);

    const handleAddParticipantInputOptionClick = useCallback(value => {
        onParticipantAddClick(value);
        setAddParticipantInputValue('');
    }, [onParticipantAddClick, addParticipantInputValue]);

    // Re-build autocomplete suggestions list every time the value changes.
    useEffect(() => {
        setAddParticipantAutocompleteOptions(
            buildAutocompleteSuggestions(addParticipantInputValue, excludedAutocompleteSuggestions)
        );
    }, [addParticipantInputValue, excludedAutocompleteSuggestions.length]);

    return (
        <ProjectCollaborationCardField label={title}>
            {duringEdit ? (
                <React.Fragment>
                    <div className="project-collaboration-labels">
                        {value.map((participant, idx) => (
                            <ItemLabel key={participant.value}
                                       option={participant}
                                       onRemoveClick={onParticipantRemoveClick}
                                       canRemove={participant.canRemove}
                            />
                        ))}
                    </div>

                    <div className="flex-center-v" style={{marginTop: '0.5rem'}}>
                        <AutocompleteTextInput
                            placeholder={__('Find')}
                            value={addParticipantInputValue}
                            options={addParticipantAutocompleteOptions}
                            onChange={handleAddParticipantInputChange}
                            onEnter={handleAddParticipantInputSubmit}
                            onOptionClick={handleAddParticipantInputOptionClick}
                        />
                        <div style={{marginLeft: '10px'}} onClick={() => setDuringEdit(false)}>
                            <IconAccept/>
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                value.length === 0 ? (
                    <div style={{display: 'flex'}}>
                        <span className="text-muted">{__('None.')}</span>
                        {editable && (
                            <div style={{marginLeft: '10px'}} onClick={() => setDuringEdit(true)}>
                                <IconEdit/>
                            </div>
                        )}
                    </div>

                ) : (
                    <div>
                        {value.map((v, idx) => {
                            if (editable && idx === value.length - 1) {
                                return (
                                    <div key={v.value} style={{display: 'flex'}}>
                                        <div>{v.text}</div>
                                        <div style={{marginLeft: '10px'}} onClick={() => setDuringEdit(true)}>
                                            <IconEdit/>
                                        </div>
                                    </div>
                                )
                            }
                            return (
                                <div key={v.value}>
                                    {v.text}
                                </div>
                            )
                        })}
                    </div>

                )
            )}
        </ProjectCollaborationCardField>
    )
}